<main class="main">
    <router-outlet></router-outlet>
    <app-user-verification></app-user-verification>
    <app-transaction-confirmation></app-transaction-confirmation>
    <app-sign-message *ngIf="isSignMessageActive" [address]="address" [msg]="msg"
        (hideEvent)="hideSign()"></app-sign-message>
    <app-alert *ngIf="showUpdateAlert" (onClose)="HideUpdateAlert()" (onAction)="UpdateToLastVersion()"
        alert-title="COMMON.UPDATE-ALERT.TITLE" [alert-description]="this.alertDescription"
        alert-action="COMMON.UPDATE-ALERT.UPDATE_ACTION"></app-alert>
    <app-alert *ngIf="showIndexDBAlert" (onClose)="HideIndexDBAlert()" (onAction)="HideIndexDBAlert()"
        alert-title="COMMON.INDEX-DB-ALERT.TITLE" alert-description="COMMON.INDEX-DB-ALERT.DESCRIPTION"
        alert-action="COMMON.INDEX-DB-ALERT.ACTION"></app-alert>
</main>
<app-toast></app-toast>